import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const LightboxImage = ({ src, alt, className = "", testid }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="block w-full cursor-zoom-in"
        data-testid={testid}
        aria-label={`View ${alt} full screen`}
      >
        <img src={src} alt={alt} className={className} />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-[100] bg-ink/90 backdrop-blur-sm flex items-center justify-center p-4 md:p-10 cursor-zoom-out"
            onClick={() => setOpen(false)}
            data-testid="lightbox-overlay"
          >
            <motion.img
              initial={{ scale: 0.92 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.95 }}
              transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
              src={src}
              alt={alt}
              className="max-w-full max-h-full w-auto h-auto rounded-xl shadow-2xl"
            />
            <span className="absolute top-5 right-5 text-bone/80 hover:text-honey transition-colors duration-300" aria-hidden="true">
              <X className="w-7 h-7" />
            </span>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
